import { ComponentActions, ComponentType, ElementsType } from '../../../state-management/model/enums/state.enums';

export interface IComponentConfig {
    canConfigure: boolean;
    canDelete?: boolean;
    canModifyGroupedElements?: boolean;
    GroupedElementsLabel?: ElementsType;
    hasAction?: {
        label: string;
        action: ComponentActions;
        icon: string;
    };
    LabelDisplay?: string;
    addLabel?: string;
    removeLabel?: string;
    addIcon?: string;
    removeIcon?: string;
}


export const _componentConfig: Record<ComponentType, IComponentConfig> = {
    [ComponentType.CardsGallery]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: true,
        GroupedElementsLabel: ElementsType.BaseCard,
        LabelDisplay: 'Kachel',
        addLabel: 'Kachel hinzufügen',
        removeLabel: 'Kachel löschen',
        addIcon: 'add',
        removeIcon: 'delete'
    },
    [ComponentType.AboutUs]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: true,
        GroupedElementsLabel: ElementsType.ComponentImageText,
        LabelDisplay: 'Element',
        addLabel: 'Element hinzufügen',
        removeLabel: 'Element löschen',
        addIcon: 'add',
        removeIcon: 'delete'
    },
    [ComponentType.ImageGallery]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: false,
        hasAction: {
            label: 'Gallery bearbeiten',
            action: ComponentActions.EditGallery,
            icon: 'edit',
        }
    },
    [ComponentType.CardsSideBySide]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: false,
    },
    [ComponentType.NavBar]: {
        canConfigure: false,
    },
    [ComponentType.Hero]: {
        canConfigure: false,
    },
    [ComponentType.ContactForm]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: false,
    },
    [ComponentType.FeatureBanner]: {
        canConfigure: false,
    },
    [ComponentType.GoogleMaps]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: false,
    },
    [ComponentType.GoogleReviews]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: false,
    },
    [ComponentType.ServiceDetails]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: false,
    },
    [ComponentType.Faq]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: true,
        GroupedElementsLabel: ElementsType.FaqItems,
        LabelDisplay: 'Frage',
        addLabel: 'Frage hinzufügen',
        removeLabel: 'Frage löschen',
        addIcon: 'add',
        removeIcon: 'delete'
    },
    [ComponentType.Quote]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: false,
    },
    [ComponentType.HighlightBox]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: false,
    },
    [ComponentType.LogoCarousel]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: false,
        hasAction: {
            label: 'Logo Karussell bearbeiten',
            action: ComponentActions.EditLogoCarousel,
            icon: 'edit',
        }
    },
    [ComponentType.SingleColumnImageButton]: {
        canConfigure: true,
        canDelete: true,
        canModifyGroupedElements: false,
    },
};
